import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserState } from '../models/user.model';

export const selectUserState = createFeatureSelector<UserState>('user');

export const userData = createSelector(
  selectUserState,
  (state: UserState) => state.user
);

export const loginRedirectRequired = createSelector(
  selectUserState,
  (state: UserState) => state.redirectRequired
);

export const getIsAuthenticated = createSelector(
  selectUserState,
  (state: UserState) => {
    const accessToken = localStorage.getItem('token');
    if (accessToken) {
      return true;
    }

    return state.loggedIn;
  }
);

export const userFlashMessages = createSelector(
  selectUserState,
  (state: UserState) => state.flashMessages
);
